import React from 'react'
import { RigidBody } from '@react-three/rapier'

export const Ground: React.FC = () => {
  return (
    <RigidBody type="fixed" position={[0, 0, 0]}>
      <mesh receiveShadow>
        <boxGeometry args={[50, 0.1, 50]} />
        <meshStandardMaterial color="#2d7d32" />
      </mesh>
    </RigidBody>
  )
} 